const video = {

	$window: $(window),

	elem: {
		$play: $('.play-button'),
		$video: $('.video')
	},

	init() {
		if (this.elem.$play.length > 0) {
			this.bindSelectors();
			this.bindUIActions();
		}
	},

	bindUIActions() {
		this.elem.$video.each(function() {
			let caption = $(this).find('figcaption').html();
			if(caption === undefined) {
				caption = '';
			}
			$(this).closest('.media').find('.media__caption').html('<p>' + caption + '<p>');
		});

		this.elem.$play.magnificPopup({
			type: 'iframe',
			closeMarkup: '<button type="button" class="mfp-close btn btn--small"><span class="show-for-sr">Close Modal</span><span class="btn__icon"><svg class="brei-icon brei-icon-close" focusable="false"><use href="#brei-icon-close"></use></svg></span></button>',
			iframe: {
				markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe></div>',				
				patterns: {
					vimeo: {
						index: 'vimeo.com/', 
						id: '/',
						src: 'https://player.vimeo.com/video/%id%?autoplay=1'
					},
					youtu: {
						index: 'youtu.be/',
						id: '/',
						src: 'https://www.youtube.com/embed/%id%?autoplay=1&modestrbranding=1&rel=0'						
					},
					youtube: {
						src: 'https://www.youtube.com/embed/%id%?autoplay=1&modestbranding=1&rel=0'
					}
				}
			}
		});

	},

	bindSelectors() {
		this.elem.$play = $('.play-button');
	}
};

export { video };
